import React from 'react'
import * as UI from 'ui/index'
import { ForEachModel, useModel, useValue } from '@morningtrain/react-resources'
import without from 'lodash/without'
import RoleSelectorForPermission from 'pages/app/settings/permissions/partials/RoleSelectorForPermission'
import * as Displays from 'support/displays'
import { ResourceSelector } from 'support/fields'

export default function InnerPermissionUsers () {
  return (
    <>
      <ResourceSelector name='selected_users' fromName='list_of_users' resourceName='users.users' operationName='select' optionsKey='name' label={' '} multiple />
    </>
  )
}
